module.exports = __webpack_public_path__ + "img/ac7.4d2f203f.jpg";